<div class="manage-edit-container">
  <app-address-form
    (onUpdateAddress)="onUpdateAddress($event)"
    (onBackPreviousPage)="backToPreviousPage()"
    [editSelectedAddress]="editUserAddress"
    *ngIf="editUserAddress">
  </app-address-form>
</div>
